import { Button, useNotify, useRedirect, useResourceContext } from 'react-admin';
import ModalComponent from '../../../components/ModalComponent';

const ConfirmUpdateEmailModal = ({ open, onClose, onSaveWithoutSend, userId, email = "", loading }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const resource = useResourceContext();

  const handleSendEmail = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/users/${userId}/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) throw new Error('Erro ao enviar e-mail');

      notify("Redefinição de senha enviada com sucesso", { type: "success" });
      onClose();
      redirect(`/${resource}`);
    } catch (error) {
      notify("Falha no envio do e-mail de redefinição de senha", { type: "error" });
      onClose();
    }
  };

  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      title="E-mail atualizado"
      content={
        <p>
          O e-mail de login será alterado para <span style={{fontWeight: "bold"}}>{email}</span>.<br/>
          Deseja enviar um link de confirmação para o novo endereço para que o usuário possa acessar a conta?
        </p> 
      }
      actions={
        <>
          <Button onClick={onSaveWithoutSend || onClose} label="Salvar sem enviar" disabled={loading} />
          <Button onClick={handleSendEmail} label="Salvar e enviar" disabled={loading} />
        </>
      }
    />
  );
};

export default ConfirmUpdateEmailModal;
